/* eslint-disable no-param-reassign */
import { createActionTypeReducer } from 'util/reducers'
import {
  normalizeSearchQueryId,
  constructGraphQLFilterObject,
} from 'ducks/searches/utils'
import {
  SEARCH_CONVERSATIONS_SUCCESS,
  FETCH_CONVERSATION_COUNTS_FOR_CHANNEL_SUCCESS,
} from '../actionTypes'

const byQueryIdInitialState = {}

function createDefaultQuery(queryId) {
  const defaultQ = {
    queryId,
    pages: {},
    sortedIds: [],
    highlights: {},
    resultsIncomplete: false,
    filter: constructGraphQLFilterObject(queryId),
  }
  return defaultQ
}

function storeQueryConversationCount({ queryType, channelId, draftState }) {
  return ({ id, conversationCount }) => {
    const queryId = normalizeSearchQueryId(
      `channel:${channelId} type:widget ${queryType}${id}`
    )
    if (!draftState[queryId]) {
      draftState[queryId] = createDefaultQuery(queryId)
    }
    Object.assign(draftState[queryId], {
      conversationCount,
    })
  }
}

export const byQueryId = createActionTypeReducer(
  {
    [FETCH_CONVERSATION_COUNTS_FOR_CHANNEL_SUCCESS]: (
      draftState,
      {
        payload: {
          data: { node },
        },
        meta: {
          requestParameters: { channelId },
        },
      }
    ) => {
      const {
        folders: { nodes: folderCounts },
        tags: { nodes: tagCounts },
        permittedAgents: { nodes: agentCounts },
      } = node

      folderCounts.forEach(
        storeQueryConversationCount({
          queryType: 'folder:fol_',
          draftState,
          channelId,
        })
      )

      tagCounts.forEach(
        storeQueryConversationCount({
          queryType: 'tag:',
          draftState,
          channelId,
        })
      )

      agentCounts.forEach(
        storeQueryConversationCount({
          queryType: 'agent:',
          draftState,
          channelId,
        })
      )

      return draftState
    },
    [SEARCH_CONVERSATIONS_SUCCESS]: (
      draftState,
      {
        payload: {
          rooms: { nodes, pageInfo, totalCount, totalPageCount },
        },
        meta: {
          requestParameters: { queryId, cursor, orderBy },
        },
      }
    ) => {
      if (!draftState[queryId]) {
        draftState[queryId] = createDefaultQuery(queryId)
      }
      // The first page doesnt have a cursor, and so its value would be null
      const searchCursor = cursor || null
      const conversationIds = nodes.map(({ id }) => id)
      const areResultsStale = !!draftState[queryId].resultsStale
      const highlights = nodes.reduce((result, conversation) => {
        // TODO: In the old system this was called search_summary. This needs
        // to be renamed to match our naming convention
        if (conversation.searchSummary)
          result[conversation.id] = conversation.searchSummary
        return result
      }, {})
      Object.assign(draftState[queryId], {
        queryId,
        totalCount,
        currentPageCursor: searchCursor,
        totalPages: totalPageCount,
        orderBy,
        loaded: true,
        errored: false,
        resultsStale: false,
        resultsIncomplete: false,
        removedConversationIds: {},
        addedConversationIds: {},
        highlights,
        pages: Object.assign(draftState[queryId].pages, {
          [searchCursor]: {
            pageInfo,
            conversationIds,
          },
        }),
        sortedIds: areResultsStale
          ? conversationIds
          : draftState[queryId].sortedIds.concat(conversationIds),
      })
      return draftState
    },
  },
  byQueryIdInitialState
)
